var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.293 7.293a1 1 0 000 1.414l6.364 6.364a1 1 0 001.414-1.414L2.414 8l5.657-5.657A1 1 0 006.657.93L.293 7.293zM40 7H1v2h39V7z",
    fill: "#7E808F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCA0MCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wLjI5Mjg5MyA3LjI5Mjg5Qy0wLjA5NzYzMSA3LjY4MzQxIC0wLjA5NzYzMTEgOC4zMTY1OCAwLjI5Mjg5MyA4LjcwNzFMNi42NTY4NSAxNS4wNzExQzcuMDQ3MzggMTUuNDYxNiA3LjY4MDU0IDE1LjQ2MTYgOC4wNzEwNyAxNS4wNzExQzguNDYxNTkgMTQuNjgwNSA4LjQ2MTU5IDE0LjA0NzQgOC4wNzEwNyAxMy42NTY5TDIuNDE0MjEgOEw4LjA3MTA3IDIuMzQzMTRDOC40NjE1OSAxLjk1MjYyIDguNDYxNTkgMS4zMTk0NSA4LjA3MTA3IDAuOTI4OTI5QzcuNjgwNTQgMC41Mzg0MDUgNy4wNDczOCAwLjUzODQwNSA2LjY1Njg1IDAuOTI4OTI5TDAuMjkyODkzIDcuMjkyODlaTTQwIDdMMSA3TDEgOUw0MCA5TDQwIDdaIiBmaWxsPSIjN0U4MDhGIi8+Cjwvc3ZnPgo=";
export { SvgArrowLeftGrey as ReactComponent };